module.exports = __webpack_public_path__ + "static/img/4-08.aa7be23.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/3/4-08.png
// module id = 239
// module chunks = 0